<template>
    <ot-section v-bind="$attrs" :theme="$otTheme" section>
        <ot-row-group :theme="$otTheme" :code="code">
            <ot-menu>
                <ot-menu-group :expand="false" :label="key" v-for="key in Object.keys(menus)" :key="key">
                    <ot-menu-item :theme="$otTheme" v-for="item in menus[key]" :key="item">{{item}}</ot-menu-item>
                </ot-menu-group>
            </ot-menu>
        </ot-row-group>
    </ot-section>
</template>

<script>
export default {
    data() {
        return {
            code: decodeURIComponent(`%3Ctemplate%3E%0A%20%20%20%20%3Cot-section%20section%3E%0A%20%20%20%20%20%20%20%20%3Cot-row-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-menu%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-menu-group%20%3Aexpand%3D%22false%22%20%3Alabel%3D%22key%22%20v-for%3D%22key%20in%20Object.keys(menus)%22%20%3Akey%3D%22key%22%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3Cot-menu-item%20v-for%3D%22item%20in%20menus%5Bkey%5D%22%20%3Akey%3D%22item%22%3E%7B%7Bitem%7D%7D%3C%2Fot-menu-item%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-menu-group%3E%0A%20%20%20%20%20%20%20%20%20%20%20%20%3C%2Fot-menu%3E%0A%20%20%20%20%20%20%20%20%3C%2Fot-row-group%3E%0A%20%20%20%20%3C%2Fot-section%3E%0A%3C%2Ftemplate%3E%0A%0A%3Cscript%3E%0Aexport%20default%20%7B%0A%20%20%20%20data()%20%7B%0A%20%20%20%20%20%20%20%20return%20%7B%0A%20%20%20%20%20%20%20%20%7D%3B%0A%20%20%20%20%7D%2C%0A%20%20%20%20computed%3A%20%7B%0A%20%20%20%20%20%20%20%20menus()%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20const%20menus%20%3D%20%7B%7D%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20for%20(let%20i%20%3D%200%3B%20i%20%3C%202%3B%20i%2B%2B)%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20const%20groupName%20%3D%20%60Group%20%24%7Bi%7D%60%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20if%20(!menus%5BgroupName%5D)%20%7B%20menus%5BgroupName%5D%20%3D%20%5B%5D%3B%20%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20for%20(let%20j%20%3D%200%3B%20j%20%3C%203%3B%20j%2B%2B)%20%7B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20menus%5BgroupName%5D.push(%60Item%20%24%7Bj%7D%60)%3B%0A%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20%7D%0A%20%20%20%20%20%20%20%20%20%20%20%20return%20menus%3B%0A%20%20%20%20%20%20%20%20%7D%2C%0A%20%20%20%20%7D%2C%0A%7D%3B%0A%3C%2Fscript%3E`),
        };
    },
    computed: {
        menus() {
            const menus = {};
            for (let i = 0; i < 2; i++) {
                const groupName = `Group ${i}`;
                if (!menus[groupName]) { menus[groupName] = []; }
                for (let j = 0; j < 3; j++) {
                    menus[groupName].push(`Item ${j}`);
                }
            }
            return menus;
        },
    },
};
</script>
